import React, { useEffect, useState } from "react";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import { Table, Button, Form } from "react-bootstrap";
import { useToast } from "../Components/toast/ToastProvider";
import {
  bulkUpsertFixedRates,
  getAllFixedRates,
} from "../Service/FixedRateService";
import { getAllFixedSources } from "../Service/FixedSourceService";
import { getALLFixedDestinations } from "../Service/FixedDestinationService";

const FixedRate = () => {
  const toast = useToast();
  const [fixedSources, setFixedSources] = useState([]);
  const [fixedDestinations, setFixedDestinations] = useState([]);
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(false);

  const loadInitialData = async () => {
    try {
      const [srcRes, destRes, rateRes] = await Promise.all([
        getAllFixedSources(),
        getALLFixedDestinations(),
        getAllFixedRates(),
      ]);

      const srcData = srcRes?.data || [];
      const destData = destRes?.data || [];
      const rateData = rateRes?.data || [];

      setFixedSources(srcData);
      setFixedDestinations(destData);

      const rateMap = {};
      rateData.forEach((r) => {
        rateMap[`${r.source_id}_${r.destination_id}`] =
          Number(r.amount).toFixed(2);

      });

      setRates(rateMap);
    } catch (err) {
      console.error("Error loading data:", err);
      toast("Failed to load data!", "ERROR");
    }
  };

  useEffect(() => {
    loadInitialData();
  }, []);

  const handleAmountChange = (source_id, destination_id, value) => {
    setRates((prev) => ({
      ...prev,
      [`${source_id}_${destination_id}`]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const records = [];

      fixedSources.forEach((src) => {
        fixedDestinations.forEach((dest) => {
          const key = `${src.id}_${dest.id}`;
          const amount = rates[key];

          if (amount && amount !== "") {
            records.push({
              source_id: src.id,
              destination_id: dest.id,
              amount: parseFloat(amount),
            });
          }
        });
      });

      console.log("Records to send:", records);

      if (records.length === 0) {
        toast("No fixed rates to save", "ERROR");
        return;
      }

      await bulkUpsertFixedRates(records);

      const formatted = {};
      records.forEach((r) => {
        formatted[`${r.source_id}_${r.destination_id}`] =
          Number(r.amount).toFixed(2);
      });
      setRates((prev) => ({ ...prev, ...formatted }));

      setTimeout(() => {
        setLoading();
        toast("Fixed rates saved successfully", "SUCCESS");

      }, 1500);


      loadInitialData();
    } catch (err) {
      console.error("Failed to save Fixed Rates:", err);
      toast("Failed to save fixed rates", "ERROR");
    }
  };

  const handleKeyDown = (e, rowIndex, colIndex) => {
    if (e.key === "Enter") {
      e.preventDefault();


      const totalRows = fixedSources.length;
      const totalCols = fixedDestinations.length;

      let nextRow = rowIndex;
      let nextCol = colIndex + 1;

      if (nextCol >= totalCols) {
        nextCol = 0;
        nextRow = rowIndex + 1;
      }

      if (nextRow >= totalRows) {
        const saveBtn = document.getElementById("fixRateSave");
        if (saveBtn) {
          saveBtn.focus();
          saveBtn.click();

        }
        return;
      }

      const nextInput = document.querySelector(`input[data-row="${nextRow}"][data-col="${nextCol}"]`);
      if (nextInput) nextInput.focus();

    }
  }

  return (
    <Main>
      <PageContainer>
        <CollapseCard title="Fixed Rate">
          <Table bordered hover responsive>
            <thead className="table-light">
              <tr>
                <th>Source</th>
                {fixedDestinations.map((d, idx) => (
                  <th key={idx}>{d.title}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {fixedSources.map((src, sIdx) => (
                <tr key={sIdx}>
                  <td>
                    <strong>{src.title}</strong>
                  </td>
                  {fixedDestinations.map((dest, dIdx) => {
                    const key = `${src.id}_${dest.id}`;
                    return (
                      <td key={dIdx} style={{ minWidth: "150px" }}>
                        <Form.Control
                          type="number"
                          size="sm"
                          min={0}
                          value={rates[key] || ""}
                          data-row={sIdx}
                          data-col={dIdx}
                          onChange={(e) =>
                            handleAmountChange(src.id, dest.id, e.target.value)
                          }
                          onKeyDown={(e) => handleKeyDown(e, sIdx, dIdx)}
                        />
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="d-flex justify-content-end mt-2">
            <Button id="fixRateSave" variant="success" onClick={handleSave} disabled={loading}>
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  saving...
                </>
              ) : (
              "Save"
              )}
            </Button>
          </div>
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default FixedRate;
